import React, { useEffect, useState } from 'react';
import Sidebar from '../components/layout/sidebar';
import Topbar from '../components/layout/Topbar';
import StatCard from '../components/common/StatCard';
import ChartCard from '../components/common/ChartCard';
import InfoListCard from '../components/common/InfoListCard';
import QuickActions from '../components/common/QuickActions';
import { supabase } from '../supabase';
import './home.css';

const Home = () => {
  const [stats, setStats] = useState({
    events: 0,
    bookings: 0,
    users: 0,
    revenue: 0,
    rating: 0,
    messages: 0,
  });

  useEffect(() => {
    if (localStorage.getItem('isAdminLoggedIn') !== 'true') {
      window.location.href = '/';
      return;
    }

    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    const { count: eventsCount } = await supabase
      .from('events')
      .select('*', { count: 'exact', head: true });

    const { count: bookingsCount } = await supabase
      .from('bookings')
      .select('*', { count: 'exact', head: true });

    const { count: usersCount } = await supabase
      .from('users')
      .select('*', { count: 'exact', head: true });

    const { count: messagesCount } = await supabase
      .from('support_messages')
      .select('*', { count: 'exact', head: true })
      .eq('status', 'pending');

    const { data: bookingsData } = await supabase
      .from('bookings')
      .select('total_amount');

    const totalRevenue =
      bookingsData?.reduce((sum, booking) => {
        return sum + Number(booking.total_amount || 0);
      }, 0) || 0;

    const { data: feedbackData } = await supabase
      .from('feedback')
      .select('rating');

    const avgRating =
      feedbackData?.length > 0
        ? (
            feedbackData.reduce((sum, review) => sum + Number(review.rating || 0), 0) /
            feedbackData.length
          ).toFixed(1)
        : 0;

    setStats({
      events: eventsCount || 0,
      bookings: bookingsCount || 0,
      users: usersCount || 0,
      revenue: totalRevenue,
      rating: avgRating,
      messages: messagesCount || 0,
    });
  };

  const upcomingEvents = [
    {
      title: 'Poetry Night: Modern Voices',
      subtitle: '2026-05-20',
      value: '45 attendees',
      status: 'confirmed',
    },
    {
      title: 'Book Club: Classic Literature',
      subtitle: '2026-05-22',
      value: '28 attendees',
      status: 'confirmed',
    },
    {
      title: 'Author Talk: Jane Austen',
      subtitle: '2026-05-25',
      value: '67 attendees',
      status: 'pending',
    },
    {
      title: 'Writing Workshop',
      subtitle: '2026-05-27',
      value: '32 attendees',
      status: 'confirmed',
    },
  ];

  const recentBookings = [
    {
      title: 'Sarah Johnson',
      subtitle: 'Poetry Night',
      value: '$25',
      status: 'paid',
    },
    {
      title: 'Michael Chen',
      subtitle: 'Book Club',
      value: '$15',
      status: 'paid',
    },
    {
      title: 'Emma Wilson',
      subtitle: 'Author Talk',
      value: '$35',
      status: 'pending',
    },
    {
      title: 'Olivia Davis',
      subtitle: 'Literary Festival',
      value: '$120',
      status: 'paid',
    },
  ];

  return (
    <div className="dashboard-page">
      <Sidebar active="Dashboard" />

      <main className="dashboard-main">
        <Topbar />

        <section className="dashboard-content">
          <div className="stats-grid">
            <StatCard title="Total Events" value={stats.events} change="↗ +12% vs last month" icon="▣" />
            <StatCard title="Total Bookings" value={stats.bookings} change="↗ +23% vs last month" icon="⌘" color="purple" />
            <StatCard title="Total Users" value={stats.users} change="↗ +8% vs last month" icon="♚" color="purple" />
            <StatCard title="Total Revenue" value={`$${stats.revenue}`} change="↗ +15% vs last month" icon="$" />
            <StatCard title="Avg Event Rating" value={stats.rating} change="↗ +0.3 vs last month" icon="☆" color="purple" />
            <StatCard title="Pending Messages" value={stats.messages} change="↘ -5 vs last month" icon="▢" color="purple" />
          </div>

          <div className="charts-grid">
            <ChartCard title="Revenue Overview" type="line" />
            <ChartCard title="Bookings by Month" type="bar" />
          </div>

          <div className="lists-grid">
            <InfoListCard title="Upcoming Events" items={upcomingEvents} />
            <InfoListCard title="Recent Bookings" items={recentBookings} />
          </div>

          <QuickActions />
        </section>

        <footer className="dashboard-footer">
          <p>© 2026 Spine Literary Events Platform. All rights reserved.</p>
          <p>Admin Dashboard v1.0</p>
        </footer>
      </main>
    </div>
  );
};

export default Home;